import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IncomingCall } from '../_models/store';

export interface CallerIdNotification {
  store_id: number;
  station?: string;
  data: IncomingCall[];
}

@Injectable({
  providedIn: 'root'
})
export class CallerIdService {

  endpoint = environment.apiUrl;
  callerId = this.endpoint + '/backend/caller-id'
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  public callSet = new BehaviorSubject<CallerIdNotification | null>(null);
  public acceptIgnreCall: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public setPhoneNumbertoOrderAndDelivery: Subject<any> = new Subject<any>();
  private pendingCallerId: any = null;

  constructor(private http: HttpClient) {}


  updateCallStatus(payload: any) {
    return this.http.post(this.callerId + `/call-status/`, payload, this.httpOptions);
  }

  setPendingCallerId(call: any): void {
    this.pendingCallerId = call;
  }

  getPendingCallerId(): any | null {
    return this.pendingCallerId;
  }

  clearPendingCallerId(): void {
    this.pendingCallerId = null;
  }
}
